import PropTypes from 'prop-types';
import React from 'react';

// material-ui
// We no longer need makeStyles from the legacy styling engine.
// import { makeStyles } from '@mui/styles';
import { Divider, List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// The old useStyles hook is no longer needed. The styles are moved to `sx` props.

const NavGroup = ({ item }) => {
    // We no longer call the useStyles() hook.
    // const classes = useStyles();

    // menu list collapse & items
    const items = item.children.map((menu) => {
        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                return <NavItem key={menu.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
            <List
                subheader={
                    item.title && (
                        <Typography
                            variant="caption"
                            // The old `className` is replaced with the `sx` prop.
                            // The sx prop can take a function to safely access the theme.
                            sx={(theme) => theme.typography.menuCaption}
                            display="block"
                            gutterBottom
                        >
                            {item.title}
                            {item.caption && (
                                <Typography
                                    variant="caption"
                                    // The old `className` is replaced with the `sx` prop.
                                    sx={(theme) => theme.typography.subMenuCaption}
                                    display="block"
                                    gutterBottom
                                >
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>

            {/* group divider */}
            {/* The old `className` is replaced with the `sx` prop. */}
            <Divider sx={{ marginTop: '2px', marginBottom: '10px' }} />
        </>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
